import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { DeSnackbarData, DeSnackbarType, DeSnackbarPosition } from './de-snackbar-config';
import { DeSnackbarRef } from './de-snackbar-ref';
import { snackbarAnimation, AnimationStep } from './de-snackbar.animation';

@Component({
  selector: 'de-snackbar',
  templateUrl: `./de-snackbar.component.html`,
  styleUrls: [`./de-snackbar.component.scss`],
  animations: [snackbarAnimation],
  standalone: false,
})
export class DeSnackbarComponent implements OnInit {
  type: DeSnackbarType = 'default';
  text: string;
  duration = 6000;
  showCloseLink = true;
  _position: DeSnackbarPosition = 'top';
  animationStep: AnimationStep = 'slideIn';
  clickEventContent = '';
  linkText = '';
  showLink = false;
  showCloseIcon = false;
  linkClick: EventEmitter<string> = new EventEmitter<string>();
  dOffset = 0;
  mOffset = 0;
  constructor(
    readonly data: DeSnackbarData,
    private ref: DeSnackbarRef
  ) {}

  ngOnInit() {
    this.loadValuesFromData();
    setTimeout(() => this.slideOut(), this.duration);
  }

  closeSnackBar() {
    this.ref.close();
  }

  slideOut() {
    this.animationStep = 'slideOut';
    setTimeout(() => this.closeSnackBar(), 200);
  }

  fadeOut() {
    this.linkClick.emit(this.clickEventContent);
    this.animationStep = 'fadeOut';
    setTimeout(() => this.closeSnackBar(), 200);
  }

  getAnimationPercentage(): string {
    const dOffset = this._position === 'bottom' ? this.dOffset * -1 : this.dOffset;
    const mOffset = this._position === 'top' ? this.mOffset * -1 : this.mOffset;
    let animationOffset = this._position === 'bottom' ? 200 : -200;
    const screenSize = window.innerWidth < 768 ? 'mobile' : 'desktop';
    if (screenSize === 'mobile') {
      animationOffset += mOffset * 2;
    } else {
      animationOffset += dOffset * 2;
    }
    return `translateY(${animationOffset}%)`;
  }

  loadValuesFromData() {
    this.type = this.data.type || this.type;
    this.clickEventContent = this.data.clickEventContent || this.clickEventContent;
    this.duration = this.data.duration || this.duration;
    this._position = this.data._position || this._position;
    this.clickEventContent = this.data.clickEventContent || this.clickEventContent;
    this.showCloseIcon = this.data.showCloseIcon || this.showCloseIcon;
    this.linkText = this.data.linkText || this.linkText;
    this.text = this.data.text || this.text;
    this.mOffset = this.data.mobileOffset || this.mOffset;
    this.dOffset = this.data.desktopOffset || this.dOffset;

    //this.throwWarningForBadInput();
  }

  /* throwWarningForBadInput() {
    if (this.linkText?.length && this.showCloseIcon) {
      console.warn(
        `DE-SNACKBAR: PLEASE DO NOT SET showCloseIcon === true
       AND PROVIDE LINK TEXT.
    ONLY THE ICON WILL BE SHOWN`);
    }
  }*/
}
